import React from 'react'
import ReactDOM from 'react-dom/client'
import 'bootstrap/dist/css/bootstrap.min.css'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { HashRouter, Route, Routes } from 'react-router-dom'
import { Provider } from 'react-redux'
import store from './store/store'
import Dashboard from './Components/Dashboard/Dashboard'
import Login from './Components/Login/Login'
import Logout from './Components/Logout/logout'
import ResetCredentials from './Components/Login/ResetCredentials'
import Register from './Components/Register/register'
import UserControl from './Components/UserControl/UserControl'
import ForgotPassword from './Components/Login/ForgotPassword'
import PIN from './Components/Login/PIN'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

function PageNotFound() {
  return (
    <div style={{ textAlign: 'center', paddingTop: '300px' }}>
      <h2>Sorry, no matching page</h2>
    </div>
  )
}

root.render(
  <Provider store={store}>
    <React.StrictMode>
      <HashRouter>
        <Routes>
          <Route path='/' element={<App />}>
            <Route path='/' element={<Dashboard />} />
            <Route path='/login' element={<Login />} />
            <Route path='/forgotPassword' element={<ForgotPassword />} />
            <Route path='/PIN' element={<PIN />} />
            <Route path='/logout' element={<Logout />} />
            <Route path='/Register' element={<Register />} />
            <Route path='/UserControl' element={<UserControl />} />
            <Route path='/Reset' element={<ResetCredentials />} />
            <Route path='*' element={<PageNotFound />} />
          </Route>
        </Routes>
      </HashRouter>
    </React.StrictMode>
  </Provider>
)
reportWebVitals()
